
export default function WhyChooseUs() {
  const features = [
    {
      icon: 'ri-award-line',
      title: '15+ Years Experience',
      description: 'Decades of expertise in vehicle wrapping, window tinting, and commercial signage with thousands of satisfied customers.',
    },
    {
      icon: 'ri-star-line',
      title: 'Premium Materials Only',
      description: 'We use only the highest quality films, vinyls, and materials from industry-leading brands for lasting results.',
    },
    {
      icon: 'ri-tools-line',
      title: 'Expert Craftsmanship',
      description: 'Our certified technicians deliver precision installation with attention to every detail for flawless results.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Comprehensive Warranty',
      description: 'All our work is backed by comprehensive warranties giving you peace of mind and protection for your investment.',
    },
    {
      icon: 'ri-time-line',
      title: 'Fast Turnaround',
      description: 'Quick and efficient service without compromising quality. Most projects completed within 1-3 business days.',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Outstanding Support',
      description: 'From initial consultation to post-installation care, we provide exceptional customer service every step of the way.',
    }
  ];

  return (
    <section id="about" className="py-20 bg-gray-900">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Why Choose Our Services?
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            We combine years of experience with cutting-edge techniques and premium materials 
            to deliver exceptional results that exceed expectations.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {features.map((feature, index) => (
            <div key={index} className="text-center group">
              <div className="w-16 h-16 flex items-center justify-center bg-blue-600 rounded-full mx-auto mb-6 group-hover:bg-blue-700 transition-colors">
                <i className={`${feature.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold text-white mb-4">{feature.title}</h3>
              <p className="text-gray-300 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gray-800 rounded-2xl p-8 md:p-12 border border-gray-700">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-white mb-6">
                Our Commitment to Excellence
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Every project we undertake reflects our dedication to superior quality and customer satisfaction. 
                From the initial consultation to final installation, we maintain the highest standards of 
                professionalism and craftsmanship.
              </p>
              <div className="space-y-4">
                <div className="flex items-center">
                  <div className="w-5 h-5 flex items-center justify-center mr-4 text-blue-400">
                    <i className="ri-check-double-line"></i>
                  </div>
                  <span className="text-gray-300">Licensed and insured professionals</span>
                </div>
                <div className="flex items-center">
                  <div className="w-5 h-5 flex items-center justify-center mr-4 text-blue-400">
                    <i className="ri-check-double-line"></i>
                  </div>
                  <span className="text-gray-300">Free consultations and detailed quotes</span>
                </div>
                <div className="flex items-center">
                  <div className="w-5 h-5 flex items-center justify-center mr-4 text-blue-400">
                    <i className="ri-check-double-line"></i>
                  </div>
                  <span className="text-gray-300">Competitive pricing with transparent costs</span>
                </div>
                <div className="flex items-center">
                  <div className="w-5 h-5 flex items-center justify-center mr-4 text-blue-400">
                    <i className="ri-check-double-line"></i>
                  </div>
                  <span className="text-gray-300">100% satisfaction guarantee</span>
                </div>
              </div>
              <button className="mt-8 bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap font-medium">
                Schedule Consultation
              </button>
            </div>
            <div className="relative">
              <img 
                src="https://static.readdy.ai/image/c209f1799ad125177e0fe6e14cfcc3f4/d98d33ad995b7357ec6c9cc41b4f5d6b.jpeg"
                alt="Professional team at work"
                className="rounded-xl object-cover object-top w-full h-80 shadow-lg"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-transparent rounded-xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
